<script lang="ts">
	export let collapsed = false;
</script>

<div
	class="advanced-setting-block"
	class:is-collapsed={collapsed}
	inert={collapsed ? true : undefined}
	aria-hidden={collapsed ? 'true' : undefined}
>
	<div class="advanced-setting-block-inner">
		<slot />
	</div>
</div>

<style>
	.advanced-setting-block {
		display: grid;
		grid-template-rows: 1fr;
		opacity: 1;
		transition:
			grid-template-rows 0.32s ease,
			opacity 0.24s ease;
	}

	.advanced-setting-block.is-collapsed {
		grid-template-rows: 0fr;
		opacity: 0;
		pointer-events: none;
	}

	.advanced-setting-block-inner {
		position: relative;
		min-height: 0;
		overflow: hidden;
		padding-left: 10px;
	}

	.advanced-setting-block:not(.is-collapsed) .advanced-setting-block-inner::before {
		content: '';
		position: absolute;
		left: 2px;
		top: 6px;
		bottom: 6px;
		width: 2px;
		border-radius: 2px;
		background: var(--color-primary);
		pointer-events: none;
	}

	.advanced-setting-block:not(.is-collapsed) .advanced-setting-block-inner {
		animation: advanced-setting-intro 0.7s ease-out forwards;
	}

	.advanced-setting-block.is-collapsed .advanced-setting-block-inner {
		animation: none;
	}

	@keyframes advanced-setting-intro {
		0% {
			box-shadow: inset 0 0 22px 6px rgba(var(--color-primary-rgb), 0.55);
		}

		100% {
			box-shadow: none;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.advanced-setting-block {
			transition: none;
		}

		.advanced-setting-block:not(.is-collapsed) .advanced-setting-block-inner {
			animation: none;
		}
	}
</style>
